<template>
  <div v-if="!hasPermission('View Plan Reports')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar />
    <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <h3 class="fw-bold m-0">Filtros de Relatório</h3>
        </div>
        <div class="card-toolbar">
          <button class="btn btn-sm btn-light me-2" @click="resetFilters">
            Limpar Filtros
          </button>
          <button class="btn btn-sm btn-primary" @click="applyFilters">
            Aplicar Filtros
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Data de Assinatura (De)</label>
            <input type="date" v-model="filters.start_date_from" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Data de Assinatura (Até)</label>
            <input type="date" v-model="filters.start_date_to" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Vencimento nos Próximos X Dias</label>
            <input type="number" v-model="filters.expiring_days" class="form-control" placeholder="Ex: 30" min="1" />
          </div>
          <div class="col-md-3">
            <label class="form-label">Status da Assinatura</label>
            <select v-model="filters.subs_status" class="form-select">
              <option value="">Todos</option>
              <option value="pending">Pendente</option>
              <option value="active">Ativo</option>
              <option value="cancelled">Cancelado</option>
              <option value="payment_failed">Falha no Pagamento</option>
              <option value="finished">Finalizado</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label">Plano</label>
            <select v-model="filters.id_plan" class="form-select">
              <option value="">Todos os Planos</option>
              <option v-for="plan in plans" :key="plan.id_plan" :value="plan.id_plan">
                {{ plan.plan_name }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <div class="form-check mt-7">
              <input class="form-check-input" type="checkbox" v-model="filters.only_overdue" id="only_overdue" />
              <label class="form-check-label" for="only_overdue">
                Apenas Inadimplentes
              </label>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-check mt-7">
              <input class="form-check-input" type="checkbox" v-model="filters.include_dependents" id="include_dependents" />
              <label class="form-check-label" for="include_dependents">
                Incluir Dependentes
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-5 mb-5">
      <div class="card-header">
        <div class="card-title">
          <h3 class="fw-bold m-0">Relatório de Planos</h3>
        </div>
        <div class="card-toolbar">
          <button class="btn btn-sm btn-danger me-2" @click="exportPdf" :disabled="loading">
            <i class="bi bi-file-pdf"></i> Exportar PDF
          </button>
          <button class="btn btn-sm btn-success" @click="exportExcel" :disabled="loading">
            <i class="bi bi-file-excel"></i> Exportar Excel
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <div v-if="loading" class="text-center py-10">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
        </div>
        <div v-else>
          <div class="mb-5">
            <span class="badge badge-light-primary fs-6">Total de registros: {{ subscribers.length }}</span>
          </div>
          <div class="table-responsive">
            <table class="table table-hover table-row-bordered">
              <thead>
                <tr class="fw-bold fs-6 text-muted">
                  <th>Tipo</th>
                  <th>Plano</th>
                  <th>Nome</th>
                  <th>CPF</th>
                  <th class="text-center">Nº Dependentes</th>
                  <th>Status</th>
                  <th>Data Assinatura</th>
                  <th>Data Vencimento</th>
                  <th>Preço Base</th>
                  <th>Preço Dep.</th>
                  <th>Total</th>
                  <th>Forma Pagamento</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(subscriber, index) in subscribers" :key="subscriber.row_key || index">
                  <td>{{ subscriber.type || '' }}</td>
                  <td>{{ subscriber.plan_name || '' }}</td>
                  <td>{{ subscriber.name || '' }}</td>
                  <td>{{ subscriber.cpf || '' }}</td>
                  <td class="text-center">{{ subscriber.type === 'Assinante' ? (subscriber.dependents_count ?? 0) : '' }}</td>
                  <td>
                    <span :class="getStatusBadgeClass(subscriber.status)">
                      {{ subscriber.status_description }}
                    </span>
                  </td>
                  <td>{{ subscriber.start_date || '' }}</td>
                  <td>{{ subscriber.end_date || '' }}</td>
                  <td>{{ subscriber.base_price ? `R$ ${subscriber.base_price}` : '' }}</td>
                  <td>{{ subscriber.dependent_price ? `R$ ${subscriber.dependent_price}` : '' }}</td>
                  <td>{{ subscriber.total_amount || '' }}</td>
                  <td>{{ subscriber.payment_method || '' }}</td>
                </tr>
                <tr v-if="subscribers.length === 0">
                  <td colspan="12" class="text-center py-10">
                    <span class="text-muted">Nenhum registro encontrado com os filtros aplicados.</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import Alert from "../../helpers/alert";
import Permission from "../../helpers/permission";

export default {
  name: "PlanReports",
  components: {
    Toolbar,
  },
  data() {
    return {
      loading: false,
      filters: {
        start_date_from: '',
        start_date_to: '',
        expiring_days: '',
        subs_status: '',
        id_plan: '',
        only_overdue: false,
        include_dependents: false,
      },
      subscribers: [],
      plans: [],
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.loadPlans();
    this.applyFilters();
  },
  methods: {
    getStatusBadgeClass(status) {
      const classes = {
        'pending': 'badge badge-warning',
        'active': 'badge badge-success',
        'cancelled': 'badge badge-danger',
        'payment_failed': 'badge badge-danger',
        'finished': 'badge badge-secondary',
      };
      return classes[status] || 'badge badge-light';
    },
    loadPlans() {
      http.get(`/places/${this.place.id_place}/plans`).then((response) => {
        this.plans = response.data.data || response.data;
      });
    },
    applyFilters() {
      this.loading = true;
      const params = this.buildExportParams();

      http.get(`/places/${this.place.id_place}/plans/reports`, { params }).then((response) => {
        this.subscribers = response.data.data || [];
        this.loading = false;
      }).catch((error) => {
        console.error('Erro ao carregar relatório:', error);
        Alert.error('Erro ao carregar relatório');
        this.loading = false;
      });
    },
    resetFilters() {
      this.filters = {
        start_date_from: '',
        start_date_to: '',
        expiring_days: '',
        subs_status: '',
        id_plan: '',
        only_overdue: false,
        include_dependents: false,
      };
      this.applyFilters();
    },
    exportPdf() {
      this.loading = true;
      const params = this.buildExportParams();
      
      http.get(`/places/${this.place.id_place}/plans/reports/export/pdf`, {
        params,
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `relatorio_assinantes_${new Date().toISOString().split('T')[0]}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.loading = false;
      }).catch((error) => {
        console.error('Erro ao exportar PDF:', error);
        Alert.error('Erro ao exportar PDF');
        this.loading = false;
      });
    },
    exportExcel() {
      this.loading = true;
      const params = this.buildExportParams();
      
      http.get(`/places/${this.place.id_place}/plans/reports/export/excel`, {
        params,
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `relatorio_assinantes_${new Date().toISOString().split('T')[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.loading = false;
      }).catch((error) => {
        console.error('Erro ao exportar Excel:', error);
        Alert.error('Erro ao exportar Excel');
        this.loading = false;
      });
    },
    buildExportParams() {
      const params = {};
      
      if (this.filters.start_date_from) {
        params.start_date_from = this.filters.start_date_from;
      }
      if (this.filters.start_date_to) {
        params.start_date_to = this.filters.start_date_to;
      }
      if (this.filters.expiring_days) {
        params.expiring_days = this.filters.expiring_days;
      }
      if (this.filters.subs_status) {
        params.subs_status = this.filters.subs_status;
      }
      if (this.filters.id_plan) {
        params.id_plan = this.filters.id_plan;
      }
      if (this.filters.only_overdue) {
        params.only_overdue = true;
      }
      if (this.filters.include_dependents) {
        params.include_dependents = true;
      }

      return params;
    },
    hasPermission(permission) {
      return Permission.has(permission);
    },
  }
}
</script>

<style scoped>
.badge {
  padding: 0.5em 0.75em;
  font-size: 0.875rem;
}
</style>
